import { render, staticRenderFns } from "./ModuleText.vue?vue&type=template&id=660b7804&scoped=true"
import script from "./ModuleText.vue?vue&type=script&lang=js"
export * from "./ModuleText.vue?vue&type=script&lang=js"
import style0 from "./ModuleText.vue?vue&type=style&index=0&id=660b7804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660b7804",
  null
  
)

export default component.exports